export default __webpack_public_path__ + "static/media/36.1503084c.png";